'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var PinterestIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path d="M7.75 11.91c-0.47 2.48-1.05 4.85-2.76 6.1-0.53-3.75 0.78-6.56 1.38-9.54-1.03-1.74 0.12-5.23 2.3-4.37 2.68 1.06-2.32 6.46 1.03 7.13 3.5 0.7 4.93-6.07 2.76-8.28-3.14-3.18-9.13-0.07-8.39 4.48 0.18 1.11 1.33 1.45 0.46 2.99-2.01-0.44-2.61-2.03-2.53-4.14 0.12-3.45 3.11-5.87 6.1-6.21 3.78-0.42 7.33 1.39 7.82 4.95 0.55 4.01-1.71 8.36-5.75 8.05-1.09-0.08-1.55-0.63-2.41-1.15z"/>';
    case 'medium':
      return '<path d="M13.786 21.165c-0.84 4.405-1.866 8.629-4.906 10.835-0.938-6.659 1.378-11.659 2.453-16.968-1.834-3.088 0.221-9.299 4.090-7.768 4.76 1.883-4.122 11.477 1.84 12.675 6.226 1.251 8.766-10.8 4.907-14.718-5.578-5.661-16.237-0.131-14.925 7.97 0.318 1.981 2.365 2.582 0.818 5.315-3.57-0.79-4.635-3.606-4.498-7.36 0.221-6.142 5.52-10.443 10.835-11.038 6.723-0.754 13.032 2.467 13.901 8.79 0.981 7.136-3.032 14.866-10.222 14.309-1.947-0.149-2.765-1.114-4.293-2.042z"/>';
    case 'large':
      return '<path d="M20.678 31.747c-1.26 6.607-2.798 12.943-7.358 16.253-1.406-9.989 2.066-17.489 3.679-25.452-2.75-4.632 0.331-13.949 6.134-11.652 7.14 2.825-6.182 17.215 2.76 19.013 9.338 1.877 13.15-16.2 7.361-22.078-8.366-8.491-24.355-0.197-22.387 11.954 0.478 2.971 3.547 3.874 1.226 7.973-5.354-1.186-6.953-5.41-6.746-11.040 0.331-9.214 8.28-15.665 16.253-16.558 10.085-1.13 19.548 3.701 20.851 13.186 1.471 10.704-4.548 22.298-15.334 21.463-2.921-0.223-4.147-1.67-6.439-3.062z"/>';
    }
  }
});

module.exports = PinterestIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Pinterest.jsx
 **/